import { useTab } from '@/hooks/useTab';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import dynamic from 'next/dynamic';
import React, { useContext } from 'react';
import { EEnterpriseTabKey } from '../../../../../interfaces/enterprise-profile/enterprise.interface';
import EnterpriseProfileStructureContext from './context/EnterpriseProfileStructureContext';
import EnterprofileTabContext from './context/EnterpriseProfileTabContext';

const EnterpriseCourseTab = dynamic(() => import('./tabs/course'));
const EnterpriseDegreeTab = dynamic(() => import('./tabs/degree'));
const EnterpriseHomepageTab = dynamic(() => import('./tabs/homepage'));
const EnterpriseInformationTab = dynamic(() => import('./tabs/information'));
const EnterpriseMemberTab = dynamic(() => import('./tabs/member'));
const EnterpriseVideosTab = dynamic(() => import('./tabs/videos'));

const hashTabPanels: { [key in EEnterpriseTabKey]: React.ReactNode } = {
  [EEnterpriseTabKey.HomePage]: <EnterpriseHomepageTab />,
  [EEnterpriseTabKey.Information]: <EnterpriseInformationTab />,
  [EEnterpriseTabKey.Member]: <EnterpriseMemberTab />,
  [EEnterpriseTabKey.Degree]: <EnterpriseDegreeTab />,
  [EEnterpriseTabKey.Course]: <EnterpriseCourseTab />,
  [EEnterpriseTabKey.Video]: <EnterpriseVideosTab />,
};

const EnterpriseTabs = () => {
  const { structure } = useContext(EnterpriseProfileStructureContext);
  const activeStructure = structure.filter((item) => item.isActive);

  const { currentTab, handleChangeTab } = useTab(activeStructure[0].tabKey);

  const selectedTab = activeStructure.find(
    (item) => item.tabKey === currentTab
  );

  return (
    <>
      <div className="lg:px-14">
        <Box
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Tabs
            value={currentTab}
            onChange={handleChangeTab}
            aria-label="enterprise-profile-tabs"
            variant="scrollable"
            scrollButtons={false}
          >
            {activeStructure.map((item) => (
              <Tab
                label={item.tabName}
                key={item.tabName}
                value={item.tabKey}
              />
            ))}
          </Tabs>
        </Box>
      </div>
      <EnterprofileTabContext.Provider value={selectedTab?.sections}>
        {hashTabPanels[currentTab]}
      </EnterprofileTabContext.Provider>
    </>
  );
};
export default EnterpriseTabs;
